import Action from './action';

const initialState = {
    IDPhotoOneFileId: '',
    IDPhotoOnePreivewUrl: '',
    errorTextOne: '',
    IDPhotoTwoFileId: '',
    IDPhotoTwoPreivewUrl: '',
    errorTextTwo: ''
};

export default (state = initialState, action: {type: string, playload: string}) => {
    switch (action.type) {
        case Action.UPDATE_CERT_PHOTO_ONE: {
            return {
                ...state,
                IDPhotoOneFileId: action.playload
            }
        }
        case Action.UPDATE_CERT_PHOTO_ONE_PREVIEW_URL: {
            return {
                ...state,
                IDPhotoOnePreivewUrl: action.playload
            }
        }
        case Action.UPDATE_CERT_PHOTO_TWO: {
            return {
                ...state,
                IDPhotoTwoFileId: action.playload
            }
        }
        case Action.UPDATE_CERT_PHOTO_TWO_PREVIEW_URL: {
            return {
                ...state,
                IDPhotoTwoPreivewUrl: action.playload
            }
        }
        case Action.UPDATE_ERROR_TEXT_ONE: {
            return {
                ...state,
                errorTextOne: action.playload
            }
        }
        case Action.UPDATE_ERROR_TEXT_TWO: {
            return {
                ...state,
                errorTextTwo: action.playload
            }
        }
        
        default: return state;
    }
}
